import React from 'react';
import { Header, PageTitleBar } from './common';
import { WhizzyLoader } from '../components';
import { SELECTOR_WIDTH } from '../util/vars';
import { useI18n } from '@whizz/react-i18n';

interface Props {
  /**
   * Prints an action at the center of the hear.
   */
  actionContent: React.ReactNode;
  /**
   * Optional content rendered right-aligned in a band below the page title.
   */
  subActionContent?: React.ReactNode;
  /**
   * Displays loader.
   */
  isLoading: boolean;
  /**
   * Layout main content.
   */
  children: React.ReactNode;

  classId?: number;
}

const HomeLayout = ({ actionContent, isLoading, children, classId, subActionContent }: Props): JSX.Element => {
  const { translate } = useI18n();
  return (
    <div className={'w-full'}>
      <Header classId={classId}>
        <div className={'flex mx-auto'} style={{
          maxWidth: SELECTOR_WIDTH,
        }}>
          {actionContent}
        </div>
      </Header>
      <PageTitleBar title={translate('global.ROUTES.HOME')} />
      {subActionContent ? (
        <div className={'w-full bg-light border-b border-gray-300'} data-hide-print>
          <div className={'max-w-screen-xl container flex justify-end py-4'}>
            {subActionContent}
          </div>
        </div>
      ) : null}
      <div className={'max-w-screen-xl container mt-md mb-xl'}>
        <WhizzyLoader show={isLoading} />
        {!isLoading
          ? children
          : null
        }
      </div>
    </div>
  );
};

HomeLayout.displayName = 'HomeLayout';

export default HomeLayout;
